import z from "zod";
import { paginationSearchValidator } from "./pagination";
import { COURSE_STATUS, COURSE_TYPE } from "@vixi/types";

const courseTypeCount = Object.keys(COURSE_TYPE).length / 2;

export const coursesSearchValidator = paginationSearchValidator
  .extend({
    userId: z.string(),
    courseType: z
      .number()
      .min(0)
      .max(courseTypeCount - 1),
    status: z.nativeEnum(COURSE_STATUS),
  })
  .partial();

export type CoursesSearchParams = z.infer<typeof coursesSearchValidator>;
